import { SearchObject } from "app/common/Model/SearchObject";
import { reportSalesAllocation } from "app/services/ReportService";
import { exportVoucherReportItem } from "app/services/VoucherItemService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportSalesAllocationStore {
  listDataSalesAllocation = null;
  searchReportSalesAllocation = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    listDepId: [],
    staffIds: [],
    positionIds: [],
    sourceIds: [],
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchSalesAllocation = (searchReportSalesAllocation) => {
    this.searchReportSalesAllocation = {
      ...this.searchReportSalesAllocation,
      ...searchReportSalesAllocation,
    };
    this.pagingReportSalesAllocation();
  };

  pagingReportSalesAllocation = async () => {
    const search = this.normalizeSearchReportVoucher(
      this.searchReportSalesAllocation
    );
    return await reportSalesAllocation({ ...search })
      .then(({ data }) => {
        this.listDataSalesAllocation = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  handleExportEmployeeReport = async (values) => {
    // if (!(values?.listDepId?.length > 0)) {
    //   toast.error("Vui lòng chọn cơ sở để xuất excel");
    //   return;
    // }
    const search = this.normalizeSearchReportVoucher(values);
    try {
      const response = await exportVoucherReportItem(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "BC_PHAN_BO_DOANH_THU_THEO_NHAN_VIEN.xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const {
      staffIds,
      listDepId,
      positionIds,
      fromDate,
      toDate,
      sourceIds,
      currentPatientSourceIds,
      currentPatientSourceDetailIds,
      listStaffGroupId,
      ...rest
    } = rawSearch;

    return {
      ...rest,
      sourceIds: Array.isArray(sourceIds) ? sourceIds.map((x) => x.id) : [],
      staffIds: Array.isArray(staffIds) ? staffIds.map((x) => x.id) : [],
      positionIds: Array.isArray(positionIds)
        ? positionIds.map((x) => x.id)
        : [],
      listStaffGroupId: Array.isArray(listStaffGroupId) ? listStaffGroupId.map((x) => x.id) : [],
      currentPatientSourceIds: Array.isArray(currentPatientSourceIds)
        ? currentPatientSourceIds.map((x) => x.id)
        : [],
      currentPatientSourceDetailIds: Array.isArray(
        currentPatientSourceDetailIds
      )
        ? currentPatientSourceDetailIds.map((x) => x.id)
        : [],
      listDepId: Array.isArray(listDepId) ? listDepId.map((x) => x.id) : [],
      fromDate: fromDate || null,
      toDate: toDate || null,
    };
  };

  resetStore = () => {
    this.listData = null;
    this.searchFee = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      listDepId: [],
    };
  };
}
